/**
 * BackendSchemaTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {BackendSchema} from "./BackendSchema";
import {BackendSchemaCollection} from "./BackendSchemaCollection";
import {BackendSchemaCommitCollection} from "./BackendSchemaCommitCollection";
import {BackendSchemaCreate} from "./BackendSchemaCreate";
import {BackendSchemaPreviewResponse} from "./BackendSchemaPreviewResponse";
import {BackendSchemaUpdate} from "./BackendSchemaUpdate";
import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";

export class BackendSchemaTag extends TagAbstract {
    /**
     * Creates a new schema
     *
     * @returns {Promise<CommonMessage>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async create(payload: BackendSchemaCreate): Promise<CommonMessage> {
        const url = this.parser.url('/backend/schema', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as CommonMessage;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Deletes an existing schema
     *
     * @returns {Promise<CommonMessage>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async delete(schemaId: string): Promise<CommonMessage> {
        const url = this.parser.url('/backend/schema/$schema_id<[0-9]+|^~>', {
            'schema_id': schemaId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'DELETE',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as CommonMessage;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a specific schema
     *
     * @returns {Promise<BackendSchema>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async get(schemaId: string): Promise<BackendSchema> {
        const url = this.parser.url('/backend/schema/$schema_id<[0-9]+|^~>', {
            'schema_id': schemaId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendSchema;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a paginated list of schemas
     *
     * @returns {Promise<BackendSchemaCollection>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getAll(startIndex?: number, count?: number, search?: string, taxonomy?: number): Promise<BackendSchemaCollection> {
        const url = this.parser.url('/backend/schema', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
                'startIndex': startIndex,
                'count': count,
                'search': search,
                'taxonomy': taxonomy,
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendSchemaCollection;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a paginated list of schema commits
     *
     * @returns {Promise<BackendSchemaCommitCollection>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getCommits(schemaId: string, startIndex?: number, count?: number, search?: string): Promise<BackendSchemaCommitCollection> {
        const url = this.parser.url('/backend/schema/$schema_id<[0-9]+|^~>/commit', {
            'schema_id': schemaId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
                'startIndex': startIndex,
                'count': count,
                'search': search,
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendSchemaCommitCollection;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a HTML preview of the provided schema
     *
     * @returns {Promise<BackendSchemaPreviewResponse>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getPreview(schemaId: string): Promise<BackendSchemaPreviewResponse> {
        const url = this.parser.url('/backend/schema/preview/:schema_id', {
            'schema_id': schemaId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendSchemaPreviewResponse;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Updates an existing schema
     *
     * @returns {Promise<CommonMessage>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async update(schemaId: string, payload: BackendSchemaUpdate): Promise<CommonMessage> {
        const url = this.parser.url('/backend/schema/$schema_id<[0-9]+|^~>', {
            'schema_id': schemaId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as CommonMessage;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
